import { TokenExpired } from 'components/tokenExpired';
import { Unauthorized } from 'components/unauthorized';
import { useCanAccess } from 'hooks';
import { AdminPatientManagement } from 'pages/patients/components/AdminPatientManagement';
import { UserPatientManagement } from 'pages/patients/components/UserPatientManagement';

export const PatientManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('patients');

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminPatientManagement />
  ) : canAccess ? (
    <UserPatientManagement />
  ) : (
    <Unauthorized />
  );
};
